import { render, staticRenderFns } from "./SchoolReviewsComponent.vue?vue&type=template&id=40cccf1c"
import script from "./SchoolReviewsComponent.vue?vue&type=script&lang=js"
export * from "./SchoolReviewsComponent.vue?vue&type=script&lang=js"
import style0 from "./SchoolReviewsComponent.vue?vue&type=style&index=0&id=40cccf1c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports